import React from 'react';

class UISelect extends React.Component
{
	render()
	{
		const { options, onChange, value, className } = this.props;

		const selectClassName = `ui-select plain ${className || ''}`.trim();

		return (
			<div className={selectClassName}>
				<select
					value={value}
					onChange={e => onChange({ value: e.target.value, label: e.target.options[e.target.selectedIndex].text })}
					className="ui-select-select"
				>
					{options.map(option => (
						<option key={option.value} value={option.value}>
							{option.label}
						</option>
					))}
				</select>
			</div>
		);
	}
}

export default UISelect;